import styled from 'styled-components'

export default styled.div`
  .menu-list {
    width: 85vw;
  }

  .cat-list {
    border-bottom: 1px solid #ececec;
    padding-top: 22px;
    padding-bottom: 22px;
  }

  .dep-name, .dep-title, .cat-title {
    font-weight: 600;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
  }

  .dep-name {
    font-size: 12px;
  }

  .dep-title {
    font-size: 14px;
    text-align: center;
    border-bottom: 1px solid #ececec;
    height: 52px;
    line-height: 51px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;

    .caret {
      width: 9px;
    }
  }

  .dep-header {
    height: 52px;

    img {
      position: absolute;
      top: 25px;
      right: 17px;
    }
  }

  .cat-title {
    font-size: 12px;
  }

  .sub-cat-name {
    font-size: 14px;
    font-family: 'Helvetica';
    font-weight: 100;
  }

  li > .caret {
    position: absolute;
    right: 20px;
    width: 9px;
  }

  .dep-menu-list {
    min-height: 100vh;
    transition: transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms;

    &.hide {
      height: 0;
      overflow: hidden;
      transform: translateX(-85vw);
      transition: transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    }
  }

  .cat-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 0;
    padding-bottom: 100px;
    transform: translateX(85vw);
    transition:
      height 0ms,
      transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    background-color: #fff;
    z-index: 10000;
    overflow: auto;

    &.show {
      max-height: 100vh;
      min-height: 100vh;
      transform: translateX(0);
      transition:
        height 0ms,
        transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/DrawerMenu.js